module.exports = __webpack_public_path__ + "static/media/David_Todt.ed9d8450.png";